
  import {Component, Vue} from "vue-property-decorator";
  import AppSwitch from "@/components/AppSwitch.vue";
  import AppDialog from "@/modules/Popup/components/AppDialog.vue";
  import {IAppState} from "@/interfaces/app-state.interface";
  import {isMobile} from "mobile-device-detect";
  import {ICookieBanner} from "@/shared/CookieBanner/interfaces/cookie-banner.interface";
  import {cookieBannerHelper} from "@/shared/CookieBanner/helpers/cookie-banner-helper";

  @Component({
    components: {
      AppDialog,
      AppSwitch,
    }
  })
  export default class CookieBannerPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'allPages', dialogName: 'cookieBannerPopup' };
    cookieConfig: ICookieBanner.ICookieConfig = {
      necessary: true,
      optional: true,
      gtm: true,
    };
    confirmActionType = ICookieBanner.ConfirmAction;
    confirmAction = ICookieBanner.ConfirmAction.Ignore;

    togglesArray = [
      {
        prop: 'necessary',
        label: 'Обязательные',
        description: 'Необходимы для работы сайта и не могут быть отключены',
        disabled: true,
      }, {
        prop: 'optional',
        label: 'Опциональные',
        description: 'Пользовательские настройки интерфейса, такие как цвет темы или отображение каких либо элементов',
      }, {
        prop: 'gtm',
        label: 'Аналитические',
        description: `
          Подключение Google Tag Manager который помогает
          Нам анализировать трафик и улучшать работу сайта.<br>
          Данные собираются анонимно и не используются для персонализации рекламы.
        `,
      },
    ];

    created() {
      let storageInfo = localStorage.getItem(ICookieBanner.LocalStorageKeys.CookieBanner);
      if (storageInfo) {
        let parsedStorageInfo: ICookieBanner.IStorageInfo = JSON.parse(storageInfo);
        this.confirmAction = parsedStorageInfo.action;
        this.cookieConfig = {...parsedStorageInfo.config};
      }
      else {
        this.confirmCookie(this.confirmAction, true);
      }
    }

    confirmCookie(confirmAction: ICookieBanner.ConfirmAction, withoutClose = false) {
      this.confirmAction = confirmAction;

      let props = ['optional', 'gtm',];
      if (this.confirmAction === ICookieBanner.ConfirmAction.ConfirmAll) {
        props.forEach(prop => this.cookieConfig[prop] = true);
      }
      if (this.confirmAction === ICookieBanner.ConfirmAction.RejectAll) {
        props.forEach(prop => this.cookieConfig[prop] = false);
      }

      let storageInfo: ICookieBanner.IStorageInfo = {
        action: this.confirmAction,
        config: this.cookieConfig,
      };
      cookieBannerHelper.updateConfigObj(storageInfo);

      if (!withoutClose) this.onClose();
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }
  }
